import { axiosInstance } from "../../Authentication/AxiosInterceptor";
import { NotesPermission } from "../../Types/Products/IProductQuestionnaire";

export type UpdateNotesPermissionsRequest = {
  notesPermissions?: NotesPermission[];
  notesDefaultPermission?: "Editor" | "Read" | "None";
};

export async function UpdateNotesPermissions(
  areaId: string, 
  request: UpdateNotesPermissionsRequest
): Promise<{ notesPermissions?: NotesPermission[]; notesDefaultPermission?: "Editor" | "Read" | "None" }> {
  try {
    console.log('API: UpdateNotesPermissions called with:', { areaId, request });
    const response = await axiosInstance.patch(`UpdateNotesPermissions/${areaId}`, request);
    console.log('API: UpdateNotesPermissions response:', response.data);
    return response.data;
  } catch (error) {
    console.error('API: UpdateNotesPermissions error:', error);
    throw error;
  }
}